// src/app/core/guards/auth.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Auth } from '@angular/fire/auth';
import { map, take } from 'rxjs/operators';
import { authState } from '@angular/fire/auth';
// import { of } from 'rxjs';
import { NEW_SIGN_IN_PAGE_URL } from 'src/app/myConstants/app.constants';

export const authGuard: CanActivateFn = (_route, state) => {
  const auth   = inject(Auth);
  const router = inject(Router);

  return authState(auth).pipe(
    take(1),
    map(user => user ? true : createLoginRedirect(router, state.url))
  );
};

function createLoginRedirect(router: Router, returnUrl: string): UrlTree {
  return router.createUrlTree([NEW_SIGN_IN_PAGE_URL], {
    queryParams: { returnUrl }
  });
}

//  no need of
//  map(user => user ? true : createLoginRedirect(router, state?.url ?? '/feed/world'))

